import React, { useState } from 'react';
import TickerTape from '@components/molecules/TickerTape';

const TickerTapeTextBlock = ({ data }) => {
  const { tickerTapeTextItems } = data;
  const [formattedItems] = useState(
    tickerTapeTextItems.map(({ text }) => text)
  );

  const [paddedItems] = useState([
    ...formattedItems,
    ...formattedItems,
    ...formattedItems
  ]);

  return (
    <TickerTape
      speed="30s"
      tickerTapeItems={paddedItems}
      bg="white"
      textTransform="uppercase"
      pb={{ base: `10`, md: `12` }}
      itemWrapperProps={{
        _odd: {
          color: `purple.600`
        },
        _even: {
          color: `white`,
          WebkitTextStroke: `2px #410286`
        }
      }}
      itemProps={{
        mr: { base: `26px`, md: `60px` },
        as: `h4`,
        letterSpacing: `0.1rem`,
        fontSize: { base: `5xl`, md: `7xl` },
        fontStyle: `italic`
      }}
    />
  );
};

export default TickerTapeTextBlock;
